import {isDesktopSafari} from 'sources/webrtc/streams/browserDetector';
import {DEFAULT_MOBILE_BREAKPOINT} from '../../sources/constants/screenSizes';

export default (breakPoint = DEFAULT_MOBILE_BREAKPOINT) => window
    && window.matchMedia(`screen and (max-width: ${breakPoint}px)`).matches
    && !isDesktopSafari();



// WEBPACK FOOTER //
// ./src/components/helpers/areWeOnMobile.js